import {
  SET_CATEGORIES,
  SET_TITLE,
  SET_DEFAULT_TITLE,
  SET_PLACEHOLDER_MESSAGE,
  SET_IS_FILL_MISSING_DATES,
} from '@/store/mutation-types'
import ChartDataService from '@/services/ChartDataService'

export default {
  state: {
    categories: [],
    series: [],
    measures: [],
    allCalculatedMeasures: [],
    geoCategories: [],
    locationCategories: [],
    wordCloudColumns: [],
    defaultLatitude: '',
    defaultLongitude: '',
    defaultLocation: '',
    categoriesLoaded: false,
    maxTitleLength: 49,
    titleText: '',
    placeHolderMessage: '',
    isFillMissingDates: true,
  },
  mutations: {
    [SET_CATEGORIES](state, categoriesData) {
      state.categories = categoriesData.categories
      state.series = categoriesData.series
      state.wordCloudColumns = categoriesData.wordCloudColumns
      state.measures = categoriesData.measures
      state.geoCategories = categoriesData.geoCategories
      state.locationCategories = categoriesData.locationCategories
      state.defaultLatitude = categoriesData.defaultLatitude
      state.defaultLongitude = categoriesData.defaultLongitude
      state.defaultLocation = categoriesData.defaultLocation
      state.categoriesLoaded = true
    },
    [SET_TITLE](state, titleText) {
      state.titleText = titleText
    },
    [SET_DEFAULT_TITLE](state, defaultTitle) {
      state.defaultTitle = defaultTitle
    },
    [SET_PLACEHOLDER_MESSAGE](state, placeHolderMessage) {
      state.placeHolderMessage = placeHolderMessage
    },
    [SET_IS_FILL_MISSING_DATES](state, isFillMissingDates) {
      state.isFillMissingDates = isFillMissingDates
    },
  },
  actions: {
    async fetchAllCategories({ state, commit, dispatch }, listIds) {
      if (!state.categories.length) {
        try {
          const responseData = (await ChartDataService.getCategories(listIds)).data
          commit(SET_CATEGORIES, responseData.categoriesData)
          responseData.warnings.forEach((warning) => {
            dispatch(
              'Notification/add',
              { type: 'warning', message: warning, duration: 4000 },
              { root: true },
            )
          })
        } catch (error) {
          const message = error.response ? error.response.data : error
          const notification = { type: 'error', message }
          dispatch('Notification/add', notification, { root: true })
        }
      }
    },
    setTitle({ commit }, titleText) {
      commit(SET_TITLE, titleText)
    },
    setDefaultTitle({ commit }, defaultTitle) {
      commit(SET_DEFAULT_TITLE, defaultTitle)
    },
    setPlaceHolderMessage({ commit }, placeHolderMessage) {
      commit(SET_PLACEHOLDER_MESSAGE, placeHolderMessage)
    },
    setIsFillMissingDates({ commit }, isFillMissingDates) {
      commit(SET_IS_FILL_MISSING_DATES, isFillMissingDates)
    },
  },
}
